import { mapGetters } from 'vuex'
import IntentText from './IntentText'
import draggable from 'vuedraggable'
import IntentPrefill from './IntentPrefill'

import ModalDialog from '@/components/elements/ModalDialog'
import specialtext from '@/components/elements/specialtext'
import uploadfile from '@/components/elements/uploadfile'
import MoveVertical from '@/components/elements/MoveVertical'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea'
import AddGenericButton from '@/components/view/chatbot/AddGenericButton'
import IntentGenericManage from './IntentGenericManage'
import IntentGetstarted from '@/components/view/intent/IntentGetstarted'
import MessageViewer from '@/components/elements/MessageViewer'
import ViewCartSummaryViewer from '@/components/elements/ViewCartSummaryViewer'
import ViewCartSummaryViewer2 from '@/components/elements/ViewCartSummaryViewer2'
import api from '@/api'
import ModalVideo from './ModalVideo'
import IntentLineFlexMessage from './IntentLineFlexMessage'
import IntentLineImageMapMessage from './IntentLineImageMapMessage'
import IntentLineImageMap from './IntentLineImageMap'
import IntentLineFlex from './IntentLineFlex'
import IntentGbPrime from './IntentGbPrime'
import IntentCartAddRemove from './IntentCartAddRemove'
// import IntentGbPrime from './IntentGbPrime'
import moment from 'moment'

export default {
    props: ['value', 'isWelcome', 'indexAlternative'],
    inject: ['$validator'],
    data: function () {
        return {
            dialog: {
                addPayment: false,
                editPayment: false
            },
            showCartaddremoveTemp: '',
            bubbleMessages: this.value,
            addLimit: this.$store.getters.getPackage == 'premium' ? 10 : 5,
            newButton: {
                title: '',
                type: 'web_url',
                url: ''
            },
            showVideo: false,
            showLineFlex: false,
            showLineImageMap: false,
            flexMessage: undefined,
            imageMap: undefined,
            showCartaddremove: false,
            editTimestamp: moment().format('x'),
            saveTimestamp: moment().format('x')
        }
    },
    components: {
        IntentText,
        draggable,
        IntentPrefill,
        IntentLineImageMapMessage,

        ModalDialog,
        specialtext,
        uploadfile,
        MoveVertical,
        AutoresizeTextarea,
        AddGenericButton,
        IntentGenericManage,
        IntentGetstarted,
        MessageViewer,
        ViewCartSummaryViewer,
        ViewCartSummaryViewer2,
        ModalVideo,
        IntentLineFlexMessage,
        IntentLineFlex,
        IntentGbPrime,
        IntentCartAddRemove,
        IntentLineImageMap
        // Modal2
    },
    computed: {
        hasAloneIntent() {
            return this.value.some(el => {
                return ['removeandaddtocart', 'addtocart', 'removetocart', 'payment'].includes(el.type)
            })
        },
        inactiveAloneIntent() {
            var vm = this
            return vm.bubbleCount >= vm.addLimit || vm.bubbleCount > 0
        },
        hasAloneIntentTooltips() {
            if (
                this.value.some(el => {
                    return ['removeandaddtocart', 'addtocart', 'removetocart'].includes(el.type)
                })
            ) {
                return this.$t('Choosing Add/Remove to cart function, the item can be used only one alone.')
            } else {
                return this.$t('Choosing GB Prime Payment function, the item can be used only one alone.')
            }
        },
        ...mapGetters({
            selectedBot: 'selectedBot',
            products: 'getProducts',
            welcomeMessage: 'welcomeMessage',
            isCoachlab: 'isCoachlab'
        }),
        bubbleCount: function () {
            var vm = this

            if (vm.bubbleMessages) {
                var count = 0
                vm.bubbleMessages.map(bubble => {
                    if (bubble.type == 'welcome_message') {
                        if (vm.welcomeMessage.messages && vm.welcomeMessage.messages[0]) {
                            count += vm.welcomeMessage.messages[0].length
                        } else {
                            count++
                        }
                    } else {
                        count++
                    }
                })
                return count
            } else {
                return 0
            }
        }
    },
    mounted: function () {
        this.resetFlexMessage()
    },
    methods: {
        changeRatio(index, payload) {
            this.$set(
                this.bubbleMessages[index],
                'ratio',
                payload == 'horizontal' ? 'horizontal' : 'square'
            )
        },
        cancelAddImageMap() {
            this.showLineImageMap = false
            this.resetImageMap()
        },
        saveAddImageMap() {
            var vm = this
            var imagemap = null

            try {
                imagemap = JSON.parse(vm.imageMap)
                vm.bubbleMessages.push({
                    ...imagemap,
                    type: 'imagemap'
                })
                vm.$emit('input', vm.bubbleMessages)
            } catch (error) { }
            vm.showLineImageMap = false
            vm.resetImageMap()
        },
        resetImageMap() {
            this.imageMap = '{}'
        },
        closecartaddremove() {
            this.showCartaddremove = false
        },
        cartaddremove() {
            var vm = this
            if (vm.bubbleCount < vm.addLimit && vm.bubbleCount <= 0) {
                this.showCartaddremoveTemp = ''
                this.showCartaddremove = true
            }
        },
        editRemoveAndAdd(item, index) {
            this.showCartaddremoveTemp = { input: [...item.data], type: item.type, index }

            this.showCartaddremove = true
        },
        updateRemoveAndAdd(obj) {
            var vm = this
            var mytext = obj.data.map(el => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
            Object.assign(this.bubbleMessages[obj.index], {
                data: obj.data,
                text: `{${obj.type}([${mytext}])}`,
                type: obj.type
            })
        },
        paymentForm(item, index) {
            var vm = this
            let input = {
                response: 'จ่ายบิลได้ที่',
                type: 'payprime',
                create: true
            }
            this.$store.commit('modalAssign', {
                component: IntentGbPrime,
                input: item.text ? { ...item.data, index, create: false } : input,
                open: true
            })
        },
        updatePaymentItem(obj) {
            Object.assign(this.bubbleMessages[obj.index], {
                data: obj,
                text: `{sendgbprimelink(${obj.detail}&&${obj.amount}&&${obj.delivery.code}&&${obj.response
                    })}`
            })
        },
        closeModal() {
            this.dialog = {
                addPayment: false,
                editPayment: false
            }
        },
        cancelAddFlexMessage: function () {
            this.showLineFlex = false
            this.resetFlexMessage()
        },
        saveAddFlexMessage: function () {
            var vm = this
            vm.bubbleMessages.push(vm.flexMessage)
            vm.$emit('input', vm.bubbleMessages)
            vm.showLineFlex = false
            vm.resetFlexMessage()
        },
        resetFlexMessage: function () {
            this.flexMessage = {
                type: 'flex',
                altText: 'You received a message',
                contents: '{}'
            }
        },
        addVideo: function (video) {
            var vm = this
            vm.bubbleMessages.push(video)
            vm.$emit('input', vm.bubbleMessages)
            vm.showVideo = false
        },
        addIntentItem: function (type, data) {
            var vm = this
            if (vm.bubbleCount >= vm.addLimit || vm.hasAloneIntent) {
                return false
            }
            if (type == 'text') {
                vm.bubbleMessages.push({
                    text: '',
                    type: type
                })
            } else if (type == 'button') {
                vm.bubbleMessages.push({
                    text: '',
                    buttons: [],
                    type: type
                })
            } else if (type == 'image') {
                vm.bubbleMessages.push({
                    image_url: '',
                    type: type
                })
            } else if (type == 'payment') {
                vm.bubbleMessages.push({
                    text: `{sendgbprimelink(${data.detail}&&${data.amount}&&${data.delivery.code}&&${data.response
                        })}`,
                    data: data,
                    type: type
                })
            } else if (['removeandaddtocart', 'addtocart', 'removetocart'].includes(type)) {
                var mytext = data.map(el => `{"pid":${el.pid},"qty":${el.qty},"option":"${el.option}"}`)
                vm.bubbleMessages.push({
                    text: `{${type}([${mytext}])}`,
                    data: data,
                    type: type
                })
            } else if (type == 'generic') {
                vm.bubbleMessages.push({
                    data: [
                        {
                            image_url: null,
                            title: '',
                            subtitle: '',
                            buttons: []
                        }
                    ],
                    type: type
                })
            } else if (type == 'welcome_message') {
                vm.bubbleMessages.push({
                    type: type
                })
            } else if (type == 'viewsummary') {
                if (vm.products.length == 0) {
                    return false
                }
                vm.bubbleMessages.push({
                    type: 'text',
                    text: '{viewsummary}'
                })
            } else if (type == 'video') {
                vm.showVideo = true
            } else if (
                type == 'line_flex' &&
                vm.$store.getters.getPackage == 'premium' &&
                !vm.isCoachlab
            ) {
                vm.showLineFlex = true
            } else if (type == 'line_imagemap' && vm.$store.getters.getPackage == 'premium') {
                vm.showLineImageMap = true
            }
            vm.$emit('input', vm.bubbleMessages)
        },
        onDelete: function (index) {
            this.bubbleMessages.splice(index, 1)
            this.$emit('input', this.bubbleMessages)
        },
        onMove: function (index, direction) {
            var vm = this
            if (direction == 'up') {
                vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index - 1, 1)[0])
            } else if (direction == 'down') {
                vm.bubbleMessages.splice(index, 0, vm.bubbleMessages.splice(index + 1, 1)[0])
            }
            vm.$emit('input', vm.bubbleMessages)
        },
        onMoveButton: function (index, direction, item) {
            var vm = this

            if (direction == 'up') {
                item.buttons.splice(index, 0, item.buttons.splice(index - 1, 1)[0])
            } else if (direction == 'down') {
                item.buttons.splice(index, 0, item.buttons.splice(index + 1, 1)[0])
            }

            vm.$emit('input', vm.bubbleMessages)
        },
        addNewButton: function (index, payload) {
            if (this.bubbleMessages[index].buttons.length < 3) {
                if (payload.type == 'web_url') {
                    delete payload.payload
                } else if (payload.type == 'postback' || payload.type == 'phone_number') {
                    delete payload.url
                }
                this.bubbleMessages[index].buttons.push(payload)
                this.newButton = {
                    title: '',
                    type: 'web_url',
                    url: ''
                }
                this.$emit('input', this.bubbleMessages)
            }
            this.saveTimestamp = moment().format('x')
        },
        editButton: function (index, bindex, payload) {
            if (this.bubbleMessages[index].buttons[bindex]) {
                // this.intentItems[index].value.buttons[index] = payload
                if (payload.type == 'web_url') {
                    delete payload.payload
                } else if (payload.type == 'postback' || payload.type == 'phone_number') {
                    delete payload.url
                }
                this.$set(this.bubbleMessages[index].buttons, bindex, payload)
                this.$emit('input', this.bubbleMessages)
            }
            this.editTimestamp = moment().format('x')
        },
        deleteButton: function (index, bindex) {
            this.bubbleMessages[index].buttons.splice(bindex, 1)
            this.$emit('input', this.bubbleMessages)
        },
        addIntentPrefill: function (index, subindex, prefill) {
            var vm = this
            let cursorPosition = this.$refs['answer_' + index + '_' + subindex][0].$el.selectionStart

            if (vm.bubbleMessages[subindex].type === 'text') {
                vm.$set(
                    vm.bubbleMessages[subindex],
                    'text',
                    [
                        vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
                        '{' + prefill + '}',
                        vm.bubbleMessages[subindex].text.slice(cursorPosition)
                    ].join('')
                )
            } else if (vm.bubbleMessages[subindex].type == 'button') {
                vm.$set(
                    vm.bubbleMessages[subindex],
                    'text',
                    [
                        vm.bubbleMessages[subindex].text.slice(0, cursorPosition),
                        '{' + prefill + '}',
                        vm.bubbleMessages[subindex].text.slice(cursorPosition)
                    ].join('')
                )
            }
            this.$emit('input', this.bubbleMessages)
        }
    },
}



// WEBPACK FOOTER //
// ./src/components/view/intent/IntentGroupItem.js